import { getOpenProjects } from "../api/openProjectsHttpClient";

export const useOpenProjectsGrid = () => {
  return { fetchGridData: getOpenProjects };
};
